import script from "./myFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./myFooter.vue?vue&type=script&setup=true&lang=js"

import "./myFooter.vue?vue&type=style&index=0&id=16de5aa8&lang=css"

const __exports__ = script;

export default __exports__